// Utility para debuggear y establecer relaciones supervisor-subordinado
import { db } from '../firebase';
import { collection, getDocs, updateDoc, doc } from "firebase/firestore";

export const debugSupervisorRelations = async () => {
  try {
    console.log('🔍 Cargando todos los empleados...');
    
    const empleadosSnapshot = await getDocs(collection(db, "empleados"));
    const empleados = empleadosSnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    
    console.log('👥 Total empleados encontrados:', empleados.length);
    console.log('\n📋 Lista de empleados:');
    
    empleados.forEach(emp => {
      console.log(`📄 ${emp.nombres || emp.nombre} ${emp.apellidos || ''}`);
      console.log(`   📧 Email: ${emp.email}`);
      console.log(`   🆔 Cédula: ${emp.cedula}`);
      console.log(`   👨‍💼 Supervisor: ${emp.supervisor_cedula || 'Sin supervisor'}`);
      console.log(`   🏢 Empresa: ${emp.empresa_id}`);
      console.log(`   📍 Departamento: ${emp.departamento || emp.departamentoNombre || 'Sin departamento'}`);
      console.log('   ---');
    });
    
    // Mapear relaciones
    console.log('\n🔗 Mapeando relaciones supervisor-subordinado:');
    
    empleados.forEach(empleado => {
      if (empleado.supervisor_cedula) {
        const supervisor = empleados.find(emp => emp.cedula === empleado.supervisor_cedula);
        if (supervisor) {
          console.log(`✅ ${empleado.nombres || empleado.nombre} es supervisado por ${supervisor.nombres || supervisor.nombre}`);
        } else {
          console.log(`❌ ${empleado.nombres || empleado.nombre} tiene supervisor_cedula ${empleado.supervisor_cedula} pero no se encontró ese supervisor`);
        }
      } else {
        console.log(`ℹ️ ${empleado.nombres || empleado.nombre} no tiene supervisor asignado`);
      }
    });
    
    // Establecer relaciones básicas de ejemplo
    console.log('\n⚙️ Estableciendo relaciones de ejemplo...');
    
    // Buscar CESAR y Estiven
    const cesar = empleados.find(emp => 
      (emp.nombres && emp.nombres.toUpperCase().includes('CESAR')) || 
      (emp.nombre && emp.nombre.toUpperCase().includes('CESAR'))
    );
    const estiven = empleados.find(emp => 
      (emp.nombres && emp.nombres.toUpperCase().includes('ESTIVEN')) || 
      (emp.nombre && emp.nombre.toUpperCase().includes('ESTIVEN'))
    );
    
    if (cesar && estiven) {
      console.log('👤 CESAR encontrado:', cesar.nombres || cesar.nombre, '- Cédula:', cesar.cedula);
      console.log('👤 Estiven encontrado:', estiven.nombres || estiven.nombre, '- Cédula:', estiven.cedula);
      
      // Hacer que CESAR sea supervisor de Estiven
      if (!estiven.supervisor_cedula || estiven.supervisor_cedula !== cesar.cedula) {
        console.log('🔄 Estableciendo a CESAR como supervisor de Estiven...');
        await updateDoc(doc(db, "empleados", estiven.id), {
          supervisor_cedula: cesar.cedula
        });
        console.log('✅ Relación establecida: CESAR supervisa a Estiven');
        return true;
      } else {
        console.log('✅ La relación ya está establecida');
        return false;
      }
    } else {
      console.log('❌ No se encontraron CESAR o Estiven en la base de datos');
      if (!cesar) console.log('   - CESAR no encontrado');
      if (!estiven) console.log('   - Estiven no encontrado');
      return false;
    }
    
  } catch (error) {
    console.error('❌ Error:', error);
    return false;
  }
};
